// extracted by mini-css-extract-plugin
module.exports = {"container":"TournamentsView_container__2j6E6","right":"TournamentsView_right__AMwFX","left":"TournamentsView_left__LeggT"};